import { deleteNotification } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { toastApiError } from "@/utils/toastApiError";
import { toastSuccess } from "@/utils/toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeleteNotification(id: number) {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteNoti, isPending } = useMutation({
    mutationKey: [NOTIFICATION_QUERY_KEYS.DELETE_NOTIFICATION, id],
    mutationFn: () => deleteNotification(id),
    onSuccess: (data) => {
      // Handle success, e.g., refetch notifications or show a success message
      toastSuccess(data.message || "Notification deleted successfully");
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATION_QUERY_KEYS.ALL_NOTIFICATIONS],
      });
    },
    onError: toastApiError,
  });

  return { deleteNoti, isPending };
}
